export default __webpack_public_path__ + "6141c5e97b46f428b58b4ebca128d18f.png";